import * as React from 'react';
import type { LexicalEditor } from '@fluentui-copilot/react-text-editor';
import { $canShowPlaceholder, mergeRegister } from '@fluentui-copilot/react-text-editor';
import { useIsomorphicLayoutEffect } from '@fluentui/react-components';

function getCanShowPlaceholder(editor: LexicalEditor): boolean {
  return editor.getEditorState().read(() => $canShowPlaceholder(editor.isComposing()));
}

export function useCanShowPlaceholder(editor: LexicalEditor): boolean {
  const [canShowPlaceholder, setCanShowPlaceholder] = React.useState(() => getCanShowPlaceholder(editor));

  useIsomorphicLayoutEffect(() => {
    function updateCanShowPlaceholder() {
      setCanShowPlaceholder(getCanShowPlaceholder(editor));
    }

    return mergeRegister(
      editor.registerUpdateListener(updateCanShowPlaceholder),
      editor.registerEditableListener(updateCanShowPlaceholder),
    );
  }, [editor]);

  return canShowPlaceholder;
}
